import React from 'react'

export default class Confirmation extends React.Component {
  constructor(props) {
    super(props);
  };

  get price() {
    return (this.props.brandkitDetails.monthlyPrice / 100).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
  }

  get laterDate() {
    const currentDate = new Date();
    currentDate.setDate(currentDate.getDate() + this.props.brandkitDetails.trialDays);
    return `${currentDate.getMonth() + 1}/${currentDate.getDate()}/${currentDate.getFullYear()}`;
  }

  render() {
    const {currentUser, creditCardLastFour} = this.props;
    return (
      <div className='content content--step3'>
        <div className='content--step3__text'>
          <p>Brandfolder Plan:</p>
          <h2>Individual - Team</h2>
          <p>Your Brandfolder subscription will withdraw monthly recurrences of ${this.price} from the account ending in {creditCardLastFour} starting on {this.laterDate}</p>
          <p>We will email confirmation to {currentUser.email} for your records.</p>
        </div>
        <button className='content--step3__btn dark' onClick={() => this.props.updateOnboarding({stage: this.props.stage + 1})}>Create My Brandfolder</button>
      </div>
    )
  }
}
